import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule, CommonModule],
  template: `
    <div class="branding">
      <a [routerLink]="['/']" class="d-flex align-items-center" style="gap: 8px;">
        <img
          src="./assets/images/logos/base-logo.png"
          class="align-middle"
          [style.width]="isTempClient ? '48%' : '90%'"
          alt="logo"
        />
        <img
          *ngIf="isTempClient"
          src="./assets/images/logos/club-beneficios-logo.png"
          class="align-middle"
          style="width: 48%;"
          alt="Club de Beneficios TDChile"
        />
      </a>
    </div>
  `,
})
export class BrandingComponent implements OnInit {
  isTempClient = false;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.isTempClient = this.authService.getProfileFromToken() === 4;
  }
}

